export class UnitConverter {
  static convert (measurement, from, to) {
    const value = Number(measurement)
    if (!Number.isFinite(value)) return NaN
    if (from === to) return value
    return UnitConverter[`swap_${from}_to_${to}`](value)
  }

  static swap_m_to_ft = (measurement) => Number((measurement * 3.28084).toFixed(4))
  static swap_ft_to_m = (measurement) => Number((measurement / 3.28084).toFixed(4))
}
